import { render, staticRenderFns } from "./RouterLinkFormat.vue?vue&type=template&id=7f787f2e"
import script from "./RouterLinkFormat.vue?vue&type=script&lang=js"
export * from "./RouterLinkFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports